'use strict';

import $ from 'jquery';
import { getLogger } from 'loglevel';
var uikit = require('../../uikit');
import { createPromotionalGiveawayNotificationBar } from '../PromotionalGiveaway/PromotionalGiveawayNotificationBar';
import ForgotPasswordForm, { createForgotPasswordForm } from './ForgotPasswordForm';
import { updatePasswordRequiredView } from './ResendEmailSuccessModal';
import * as featureFlags from '../../utilities/featureFlags';
import userService from '../../services/CartUserService';
import utilities from '../../js/utilities';
import { createBomNotificationBar } from '../BomModal/BomNotificationBar';
import { EnableAdobeAnalytics } from '../../utilities/featureFlags';
import cookies from 'js-cookie';
import cartApi from '../../services/CartAPI';

const log = getLogger('LoginView');
var Backbone = require('backbone'),
  config = require('../../js/config'),
  LockedOutModalView = require('./LockedOutModal'),
  LoginAPI = require('./LoginAPI'),
  Analytics = require('../Analytics/Analytics'),

  LoginFormView = Backbone.View.extend({
    events: {
      'submit': 'submitForm',
      'click .js-signup-link': 'createAccountBtn'
    },
    initialize: function() {
      import('../ForgotPassword/Password').then(function(importedItem)
      {
        uikit.components.register(importedItem.create);
      });
      if (config.promoGiveaway.promotionalGiveawayDashboardItemName && document.location.href.indexOf(config.promoGiveaway.promotionalGiveawayDashboardItemName) !== -1) {
        this.showPromoGiveawayNotificationBar().done(contentResponse => {
          contentResponse = JSON.parse(contentResponse);
          let $promotionalGiveawayNotification = $('#PromoGiveawayOrderConfirmationNotification');
          createPromotionalGiveawayNotificationBar($promotionalGiveawayNotification, contentResponse);
          mediator.trigger(config.events.ui.ajaxContentLoaded, $promotionalGiveawayNotification);
        })
          .fail((errResponse) => {
            log.error(errResponse);
          });
      }
      if (Arrow.isAuthorized) {
        // Don't show the login page if we are already authenticated
        document.location.href = '/';
      }
      this.analyticsConfig = config.analytics;
      this.$loginFormSubmit = this.$el.find('.LoginForm-submit');
      this.$username = this.$el.find('.LoginForm-username');
      this.$password = this.$el.find('.LoginForm-password');
      this.$loyaltyContainer = this.$el.find('.LoyaltyContainer');
      this.$loyaltyCheck  = this.$el.find('#LoyaltyCheck');
      this.$loyaltyEmailPreference  = this.$el.find('#LoyaltyEmailPreference');
      if (featureFlags.EnableCommonLoginResetModal.isEnabled()) {
        this.initializeForgotPasswordForm();
      }

      if (featureFlags.EnableLoyaltyMVP.isEnabled() && document.location.search.toLowerCase().indexOf('loyaltyoptin=true') >= 0) {
        this.$loyaltyContainer.show();
      }

      this.$username.focus();
      let currentPath = window.location.href;
      if (currentPath.includes('validateBOM=true') && !(currentPath.includes('gotoSplash=true'))) {
        let $bomNotificationBar = $('#BomNotificationBar');
        createBomNotificationBar($bomNotificationBar);
      }
      if (EnableAdobeAnalytics.isEnabled()) {
        this.apiValidation = false;
        Analytics.pushFormInteractionData('form_start', 'Login');
      }
      $('.mtcaptcha').css('display', 'none');
    },
    initializeForgotPasswordForm() {
      createForgotPasswordForm(this.$el);
    },
    initializeUpdatePasswordRequiredView() {
      updatePasswordRequiredView($('.update-password-required'), this.$username.val(), this.$password.val());
      //TODO 1: back button listener to show login screen

    },
    showPromoGiveawayNotificationBar: function() {
      let url = config.promoGiveaway.orderConfirmationNotificationUrl + config.promoGiveaway.loginConfirmationNotificationItemId;
      return $.ajax({
        type: 'GET',
        url: url,
        contentType: 'application/JSON'
      });
    },
    submitForm: function(e) {
      e.preventDefault();
      if (this.$el.valid()) {
        if (EnableAdobeAnalytics.isEnabled()) {
          this.apiValidation = true;
        }
        this.$loginFormSubmit.addClass(config.classes.isWhite).addClass(config.classes.loadingClass);
        const response = LoginAPI.login(this.$username.val(), this.$password.val());
        response.then((data) => {
          if (data.isPasswordUpdateRequired) {
            $('g-recaptcha').css('display', 'none');
            $('.login-page-container').hide();
            $('.update-password-required').css('display', 'block');
            this.initializeUpdatePasswordRequiredView();
            return;
          }
          if (data.success) {
            let allRequests;
            let loyaltyChecked = this.$loyaltyCheck && this.$loyaltyCheck.length > 0 && this.$loyaltyCheck[0].checked;
            let loyaltyEmailChecked = this.$loyaltyEmailPreference && this.$loyaltyEmailPreference.length > 0 && this.$loyaltyEmailPreference[0].checked;
            if (featureFlags.EnableLoyaltyMVP.isEnabled() && loyaltyChecked) {
              let crossDomainRequest = LoginAPI.getCrossDomainLogin(data);
              let loyaltyRequests = LoginAPI.setLoyaltyPreference(data.loyaltyOptInUrl, this.$username.val(), loyaltyChecked, loyaltyEmailChecked || null);
              allRequests = crossDomainRequest.concat(loyaltyRequests);
            } else {
              allRequests = LoginAPI.getCrossDomainLogin(data);
            }
            Promise.all(allRequests)
              .then(() => {
                log.info('Crossdomainlogin succeeded');
                this.pushLoginAnalytics(true);
                if (featureFlags.EnableLoyaltyMVP.isEnabled() && loyaltyChecked) {
                  this.pushPerksAnalytics();
                }
                sessionStorage.setItem(config.sessionVariables.marketingTracking.userJustLoggedInCookie, this.$username.val());
                //Force API Call to update cart items in local storage
                utilities.sessionStorageRemove('b2busers', '');
                utilities.sessionStorageRemove('cart', '');

                userService.getUserInfo().then(() => {
                  //If loyalty FF enabled always redirect to perks page
                  let b2bUserData = utilities.sessionStorageLoad('b2busers');
                  let token = cookies.get(config.cookies.accessToken);
                  if (featureFlags.EnableEUCFieldsPh2.isEnabled() && token && (b2bUserData && !b2bUserData.eucCustomerInfo || (b2bUserData && b2bUserData.eucCustomerInfo && b2bUserData.eucCustomerInfo.eucExpired))) {
                    let encodeURL = encodeURIComponent(data.redirectUrl);
                    window.location.href = `/profileupdate?token=${token}&url=${encodeURL}`;
                  } else {
                    if (featureFlags.EnableLoyaltyMVP.isEnabled()) {
                      window.location.href = featureFlags.EnableLoyaltyPoints.isEnabled() && document.location.search.toLowerCase().indexOf('cartloyalty=true') >= 0 ? config.urls.cart.cart :
                        (document.location.search.toLowerCase().indexOf('loyaltyoptin=true') >= 0 ? config.urls.users.perks : data.redirectUrl);
                    }
                    else {
                      window.location.href = data.redirectUrl;
                    }
                  }
                });
              })
              .catch(err => log.error('Crossdomainlogin failed ' + err));
          } else {
            this.handleFailedLogin(data);
            if (EnableAdobeAnalytics.isEnabled()) {
              Analytics.pushFormErrorData('Login', this.getErrorMessages('apiValidation'));
            }
          }
        });
      }
      else {
        if (!this.$username.val() || !this.$username.valid())
          this.$username.focus();
      }
      $('span.is-invalid').addClass('error-message-icon');
      if (this.$el.find('.loginFail').css('display') === 'block') {
        this.$el.find('.loginFail').css('display', 'none');
      }
      if (this.$el.find('.forgottenAccount').css('display') === 'block') {
        this.$el.find('.forgottenAccount').css('display', 'none');
      }
      if (EnableAdobeAnalytics.isEnabled() && !this.apiValidation) {
        Analytics.pushFormErrorData('Login', this.getErrorMessages('formValidation'));
      }
    },

    handleFailedLogin: function(response) {
      if (!response.success) {
        this.$loginFormSubmit.removeClass(config.classes.isWhite).removeClass(config.classes.loadingClass);
        if (response.modalMessage === config.events.forgotPassword.forgottenUser || response.modalMessage === config.events.forgotPassword.externalForgottenUser) {
          this.$el.find('.forgottenAccount').addClass(config.classes.isActive);
          this.$el.find('.loginFail').removeClass(config.classes.isActive);
          if (this.$el.find('.forgottenAccount').css('display') === 'none') {
            this.$el.find('.forgottenAccount').css('display', 'block');
          }
        } else {
          this.$el.find('.loginFail').addClass(config.classes.isActive);
          this.$el.find('.forgottenAccount').removeClass(config.classes.isActive);
          if (this.$el.find('.loginFail').css('display') === 'none') {
            this.$el.find('.loginFail').css('display', 'block');
          }
        }
        this.pushLoginAnalytics(false);
        if (response.showModal) {
          this.showErrorModal(response.modalTitle, response.modalMessage);
        }
      }
    },
    showErrorModal: function(title, message) {
      if (featureFlags.EnableCommonLoginResetModal.isEnabled())
      {
        let modal = new ForgotPasswordForm();
        let data = {
          'event': config.analytics.events.error,
          'category': config.analytics.categories.login,
          'action': config.analytics.actions.loginAttempt,
          'label': config.analytics.labels.userLockedOut
        };
        Analytics.emitNewDataLayerEvent(data);
        modal.open({message: message});
      }
      else
      {
        let modal = new LockedOutModalView();
        modal.open({ title: title, message: message });
      }
    },
    pushPerksAnalytics: function() {
      Analytics.emitNewDataLayerEvent({
        event: config.analytics.eventTypes.Click,
        action: config.analytics.actions.Login,
        category: config.analytics.categoryTypes.ArrowPerks,
        label: config.analytics.labelTypes.NonMemberPerksJoin
      });
    },
    getErrorMessages: function (validationType) {
      let error_messages = [];
      if (validationType === 'formValidation') {
        let $errorSpan = this.$el.find('.is-invalid').filter('span');
        let $errorLabel = this.$el.find('.is-invalid').filter('label');
        $errorSpan.each(function () {
          let $span = $(this);
          if ($span.css('display') === 'block') {
            let errorMessage = $span.text().trim() || undefined;
            error_messages.push({
              error_message: errorMessage,
              form_field_type: ''
            });
          }
        });
        $errorLabel.each(function (index) {
          let $label = $(this);
          let formFieldLabel = $label.text().trim() || undefined;
          error_messages[index].form_field_type = formFieldLabel;
        });
      } else {
        if (validationType === 'apiValidation') {
          let $loginFail = this.$el.find('.loginFail');
          let $forgottenAccount = this.$el.find('.forgottenAccount');
          if ($loginFail.css('display') === 'block') {
            error_messages.push({
              error_message: $loginFail[0].innerText.trim() || undefined,
              form_field_type: undefined
            });
          }
          if ($forgottenAccount.css('display') === 'block') {
            error_messages.push({
              error_message: $forgottenAccount[0].innerText.trim() || undefined,
              form_field_type: undefined
            });
          }
          this.apiValidation = false;
        }
      }
      return error_messages;
    },
    pushLoginAnalytics: function(isSuccess) {
      let pushData = {
        event: this.analyticsConfig.events.click,
        category: this.analyticsConfig.categories.login,
        action: this.analyticsConfig.actions.click,
        label: (isSuccess ? this.analyticsConfig.labels.success : this.analyticsConfig.labels.fail)
      };
      if (EnableAdobeAnalytics.isEnabled()) {
        if (isSuccess) {
          Analytics.adobeAccountData(this.$username.val(),'account_login');
          Analytics.pushFormInteractionData('form_submit', 'Login');
        }
      } else {
        Analytics.pushToEventFramework(pushData);
      }
    },
    createAccountBtn: function() {
      if (EnableAdobeAnalytics.isEnabled()) {
        Analytics.adobeAccountData('','account_CreateStart');
        Analytics.pushFormInteractionData('form_start', 'Get Started');
      }
    }
  },
  {
    create: function($parent) {
      $parent.find('.LoginForm').each(function(n, el) {
        new LoginFormView({
          el: el
        });
      });
    }
  });

module.exports = LoginFormView;



// WEBPACK FOOTER //
// ./assets/components/Login/LoginView.js